const ScoreBox = ({ currentScore, scoreIsLoading }) => {

  // Styling for the box
  const boxStyle = {
    borderRadius: "10px",
    fontSize: "18px",
    fontWeight: "bold",
    testAlign: "center",
    // boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)", // Add some shading
    transition: "background-color 0.5s ease, color 0.5s ease" // shading transition 
    // background: {linear-gradient(180deg,#ccc 0,#eee 30%,#fff)}
  };

  const textStyle = {
    display: "inline-block",
    lineHeight: "1", // Fix line height for proper vertical centering
    minWidth: "7ch", // Ensures consistent width for 5 characters, including minus and decimal
    textAlign: "center",
    opacity: scoreIsLoading ? 0.25 : 1
  };

  // Determine the background color and displayed score based on currentScore
  const isPositive = currentScore >= 0;
  const formattedScore = currentScore !== undefined && 
    (isPositive ? "B+" + String(currentScore) : "W+" + String(-currentScore)); // Show absolute value for negative scores
  // const newNextMoveScore = nextMoveScore !== undefined ? nextMoveScore : '' 
  
  boxStyle.backgroundColor = isPositive ? "black" : "white"
  boxStyle.color = isPositive ? "white" : "black"

  return (
    <div className="score-box" style={boxStyle}>
      <span style={textStyle}>{formattedScore && formattedScore}</span>
      {/* <span style={textStyle}>{displayNextMoveScore}</span> */}
    </div>
  );
};

export default ScoreBox;
